import { useState } from 'react';
import { Text, VStack, Stack, Radio, RadioGroup } from '@chakra-ui/react';
import { SubmitStepButton } from './SubmitStepButton';
import { IStep } from './interfaces';
import { useNotificationCentralContext } from '../notification-central.context';

export function ChooseMethodStep({HeaderComponent, onSubmit}: IStep) {
  const {setFormData, formData} = useNotificationCentralContext();
  const [notificationType, setNotificationType] = useState(formData?.notificationType);

  const handleSubmit = () => {
    setFormData((oldData) => ({...oldData, notificationType}))
    onSubmit();
  }

  return (
    <>
    <HeaderComponent title={"Tipo de comunicação"} />
    <VStack paddingY={2} justifyContent={"flex-start"} alignItems={"flex-start"}>
      <Text fontWeight={'bold'}>Selecione abaixo o tipo de comunicação que voce deseja usar</Text>
      <RadioGroup
        onChange={(value: string) => {
          setNotificationType(value);
        }}
        value={notificationType}
      >
        <Stack justifyContent={"flex-start"} >
          <Radio value="email">Email</Radio>
          <Radio value="push">Push Notification</Radio>
          <Radio value="sms" isDisabled>
            SMS
          </Radio>
        </Stack>
      </RadioGroup>
      <SubmitStepButton onSubmit={handleSubmit} />
    </VStack>
    </>
  );
}
